function requestUserID() {
  Twitch.ext.actions.requestIdShare();
}

export default {
  requestUserID
};
